// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1PvpO","header":"ReportDetails_header__2MtS-","title":"ReportDetails_title__BOBX_","left":"ReportDetails_left__1UEY7"};